import React from 'react';
import { Layout } from '../components/Layout';
import { Store } from '../components/Store';
export const MerchPage = () => {
  return <Layout data-id="element-313">
      <div className="pt-32 bg-pattern-dark min-h-screen" data-id="element-314">
        <div className="container mx-auto px-4" data-id="element-315">
          <div className="text-center mb-16" data-id="element-316">
            <h1 className="font-display italic text-4xl sm:text-6xl font-bold mb-6 text-white" data-id="element-317">
              Official <span className="text-red-500" data-id="element-318">Merchandise</span>
            </h1>
            <p className="font-body italic text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-319">
              Copywrite needed
            </p>
          </div>
        </div>
        <Store data-id="element-320" />
      </div>
    </Layout>;
};